import React from 'react';
import history from 'lib/history';
import styled from 'styled-components';
import { Layout, Avatar } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import userStore from 'store/user';
import { observer, useObserver } from 'mobx-react';
import Merchant from './merchant';
import CompanySideMenu from './company';
import { IMerchant } from 'interfaces/user';
import accountManageStore from 'store/account-manage';
import { EAuthority } from 'interfaces/account-manage';
import gtm from '@/lib/gtm';

const { Sider } = Layout;
type IProps = RouteComponentProps<{ component: string }>;

const SideMenu = observer((props: IProps) => {
  const handleProfileClick = () => {
    // TODO check if it is on the new tab
    gtm.track('ModuleClick', { module: 'profile' });
    if (!userStore.currentMerchantId && accountManageStore.authorities.includes(EAuthority.ViewProfile)) {
      history.push('/main/profile');
    }
  };
  const getMerchantName = (merchantId: string): IMerchant | undefined => {
    const currentMerchant = userStore.merchantList.filter(el => el.merchantId === merchantId);
    return currentMerchant[0];
  };

  return useObserver(() => {
    const merchant = userStore.currentMerchantId ? getMerchantName(userStore.currentMerchantId) : false;
    return (
      <SideMenuWrapper collapsedWidth={0} defaultCollapsed={false} collapsible={true}>
        <ProfileWrapper merchantId={userStore.currentMerchantId}>
          <div className="profile" onClick={handleProfileClick}>
            <Avatar
              size={60}
              shape="circle"
              src={
                (merchant && merchant.merchantProfileUrl!) ||
                userStore.userProfile.profilePhotoUrl ||
                require('assets/image/merchant-logo.png')
              }></Avatar>
            <div className="name">{userStore.userProfile.username}</div>
          </div>
          {userStore.userProfile.type === 'COMPANY' ? <CompanySideMenu /> : <Merchant />}
        </ProfileWrapper>
      </SideMenuWrapper>
    );
  });
});

export default withRouter(SideMenu);
const ProfileWrapper = styled.div<{ merchantId: string }>`
  .profile {
    display: flex;
    margin: 26px 0 25px 21px;
    align-items: center;
    cursor: ${props => (props.merchantId ? 'auto' : 'pointer')};

    /* cursor: pointer; */

    .name {
      word-break: break-word;
      max-width: 120px;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 20px;
      padding-left: 10px;
    }
  }
`;

const SideMenuWrapper = styled(Sider)`
  max-width: 220px !important;
  width: 220px !important;
  background: #333333 !important;

  .ant-layout-sider-zero-width-trigger.ant-layout-sider-zero-width-trigger-left {
    top: 0;
    background: #333333;
  }

  .ant-menu {
    background: #333333;
    font-size: 14px;
    color: #fcfcfc;
    letter-spacing: 0;
    line-height: 24px;
    opacity: 0.8;
  }

  .ant-menu.ant-menu-light.ant-menu-root.ant-menu-inline {
    border-right: 1px solid #333333;
  }

  .version,
  .server-version {
    position: absolute;
    bottom: 0;
    color: #fff;
    width: 100%;
    text-align: center;
  }
  .version {
    margin-bottom: 40px;
  }
  .server-version {
    margin-bottom: 10px;
  }
  .ant-menu-item-only-child {
    padding-left: 24px !important;
  }
  .ant-menu-submenu-title :not(:hover) {
    .ant-menu-submenu-arrow::before,
    .ant-menu-submenu-arrow::after {
      background: white !important;
    }
  }
`;
